// Pricing data
export interface PricingTier {
    value: string;
    label: string;
    monthly: number | null;
    annual: number | null;
    storage: string;
    custom?: boolean;
    popular?: boolean;
    yearlySalePrice?: number;
    automatedValue?: string;
}




export const automatedPriceMonthly = {
    "200": { price: 49, webinars: 2, storage: "2 GB" },
    "500": { price: 79, webinars: 2, storage: "5 GB" },
    "3000": { price: 143, webinars: 4, storage: "10 GB" },
    "6000": { price: 242, webinars: 4, storage: "10 GB" },
    "10000": { price: 396, webinars: 6, storage: "10 GB" },
    "10000+": { price: "**", webinars: "6+", storage: "Custom" }
};

export const automatedPriceYearly = {
    "200": { price: 41, webinars: 2, storage: "2 GB" },
    "500": { price: 66, webinars: 2, storage: "5 GB" },
    "3000": { price: 119, webinars: 4, storage: "10 GB" },
    "6000": { price: 201, webinars: 4, storage: "10 GB" },
    "10000": { price: 330, webinars: 6, storage: "10 GB" },
    "10000+": { price: "**", webinars: "6+", storage: "Custom" }
};

export const allInOnePriceMonthly = {
    "100": { price: 116, webinars: 3, storage: "2 GB" },
    "300": { price: 198, webinars: 3, storage: "5 GB" },
    "1000": { price: 396, webinars: 3, storage: "10 GB" },
    "3000": { price: 299, webinars: 6, storage: "10 GB" },
    "6000": { price: 449, webinars: 6, storage: "10 GB" },
    "6000+": { price: "**", webinars: "6+", storage: "Custom" }
};

export const allInOnePriceYearly = {
    "100": { price: 96, webinars: 3, storage: "2 GB" },
    "300": { price: 165, webinars: 3, storage: "5 GB" },
    "1000": { price: 330, webinars: 3, storage: "10 GB" },
    "3000": { price: 249, webinars: 6, storage: "10 GB" },
    "6000": { price: 374, webinars: 6, storage: "10 GB" },
    "6000+": { price: "**", webinars: "6+", storage: "Custom" }
};


export const LIVE_PRICES: PricingTier[] = [
    { value: '50', label: '50 Attendees', monthly: 44, annual: 36, yearlySalePrice: 44, storage: '2GB' },
];

export const AUTOMATED_PRICES: PricingTier[] = [
    { value: '3000', label: '3000 Attendees', monthly: 144, annual: 119, yearlySalePrice: 144, storage: '10GB' },
    { value: '6000', label: '6000 Attendees', monthly: 242, annual: 201, yearlySalePrice: 242, storage: '10GB' },
    { value: '10000', label: '10000 Attendees', monthly: 396, annual: 330, yearlySalePrice: 396, storage: '10GB' },
];

export const LIVE_AUTO_PRICES: PricingTier[] = [
    { value: '200', automatedValue: '1000', label: '50 Live & 200 Automated', monthly: 116, annual: 96, yearlySalePrice: 116, storage: '2GB' },
    { value: '500', automatedValue: '2500', label: '250 Live & 500 Automated', monthly: 198, annual: 165, yearlySalePrice: 198, storage: '5GB' },
    { value: '1000', automatedValue: '5000', label: '500 Live & 3,000 Automated', monthly: 396, annual: 330, yearlySalePrice: 396, storage: '10GB', popular: true },
]; 


// ======================= new pricing data =======================

export interface IPricingAddon {
    id: string;
    title: string;
    description: string;
    price: number;
    chargeIdMontly: string;
    chargeIdYearly: string;
}

export const PricingAddons: IPricingAddon[] = [
    {
        id: 'easycrm',
        title: 'EasyCRM',
        description: 'Complete CRM & automation',
        price: 49,
        chargeIdMontly: 'EasyCRM-USD-Monthly',
        chargeIdYearly: 'EasyCRM-USD-Yearly',
      },
      {
        id: 'paidwebinars',
        title: 'Paid Webinars',
        description: 'Monetize your webinars',
        price: 49,
        chargeIdMontly: 'Paid-Webinar-USD-Monthly',
        chargeIdYearly: 'Paid-Webinar-USD-Yearly',
    }
];

interface PriceInfo {
    planName: string;
    montly: number;
    annualPlanPerMonth: number;
    annualMaxPrice: number;
    offPercent?: number;
    addons?: string[];
    liveAttendees?: number;
    attendees?: number;
    automatedAttendees?: number;
}

export interface AllInOnePrices {
    events: Record<"50" | "200" | "500" | number, PriceInfo>;
    funnels: Record<"3000" | "6000" | "10000" | number, PriceInfo>;
}
export const ALL_IN_ONE_PRICES: AllInOnePrices = {
  events: {
    "50": { planName: "Launch", montly: 44, annualPlanPerMonth: 36, annualMaxPrice: 44, addons: [], liveAttendees: 50, automatedAttendees: 0 },
    "200": {
      planName: "Pro",
      montly: 116,
      annualPlanPerMonth: 96,
      annualMaxPrice: 214,
      offPercent: 55,
      addons: ["easycrm", "paidwebinars"],
      liveAttendees: 200,
      automatedAttendees: 1000,
    },
    "500": {
      planName: "Growth",
      montly: 198,
      annualPlanPerMonth: 165,
      annualMaxPrice: 296,
      offPercent: 44,
      addons: ["easycrm", "paidwebinars"],
      liveAttendees: 500,
      automatedAttendees: 2500,
    },
  },
  funnels: {
    "3000": {
      planName: "Starter",
      montly: 144,
      annualPlanPerMonth: 120,
      annualMaxPrice: 242,
      addons: ["easycrm", "paidwebinars"],
      automatedAttendees : 3000,
    },
    "6000": {
      planName: "Growth",
      montly: 242,
      annualPlanPerMonth: 201,
      annualMaxPrice: 340,
      addons: ["easycrm", "paidwebinars"],
      automatedAttendees : 6000,
    },
    "10000": {
      planName: "Scale",
      montly: 396,
      annualPlanPerMonth: 330,
      annualMaxPrice: 494,
      addons: ["easycrm", "paidwebinars"],
      automatedAttendees : 10000,
    },
  },
};